"use strict";
/**
 * Markets Formatters
 * Formatting functions for market display
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMarketPrice = formatMarketPrice;
exports.formatMarketSpread = formatMarketSpread;
exports.getMarketDepthString = getMarketDepthString;
/**
 * Format market price for display
 */
function formatMarketPrice(market) {
    const midPrice = (market.bid + market.ask) / 2;
    return midPrice.toFixed(2);
}
/**
 * Format market spread for display
 */
function formatMarketSpread(market) {
    const spread = market.ask - market.bid;
    return spread.toFixed(4);
}
/**
 * Get market depth display string
 */
function getMarketDepthString(market) {
    return `$${market.bid.toFixed(2)} / $${market.ask.toFixed(2)}`;
}
